import { getStoreScopedPath } from "@redotech/redo-merchant-app-common/routing/store-scope";

/**
 * The store-scoped callback for an unscoped TikTok callback whose `state` names
 * the store. Undefined when it is already scoped or `state` is not a team id.
 */
export function getTiktokCallbackPath(url: URL): string | undefined {
  if (url.pathname !== "/tiktok/callback") {
    return undefined;
  }

  const teamId = url.searchParams.get("state");
  if (!teamId || !/^[0-9a-f]{24}$/.test(teamId)) {
    return undefined;
  }

  return getStoreScopedPath(teamId, url.pathname + url.search + url.hash);
}
